export const usersEmailChange = {
  id: 1,
  email: 'user_admin@bmiq.com',
  newEmail: 'user_admin@bmiq.com',
  isVerifiedNewEmail: false,
  oldActivatedEmail: null,
  isVerified: true,
  verifiedDate: '2021-03-03T08:46:40.424Z',
  verifyToken: '46745b20a7ec881cc18eac164e4237',
  verifyExpires: '2021-03-10T20:39:30.104Z',
  resetToken: '$2b$11$dQXV4bnSmCYHfm.yK7mm5OztMOI9sHVF1acvmjMNw.NFXHI0rvMPy',
  resetExpires: '2021-03-08T13:27:15.188Z',
  lastIpAddress: '::1',
  currentIpAddress: '::1',
  timezone: null,
  accountsExpired: false,
  isWorkFactorChanged: true,
  accountLocked: false,
  credentialsExpired: false,
  accountEnabled: true,
  type: 'organization-admin',
  isUserReminded: 'never-reminded',
  loginAttempts: 0,
  userIdentifier: '483a42d338f79830ca5fd11f64aee8d070e98da9_1614761200573@intellihealth.com',
  deduUserId: 374562,
  bmiqUserId: null,
  migratedAt: null,
  migrateMessageShowed: false,
  isSubscribed: false,
  accountAccessToken: 'b5e55503ee33eca82483e12be4c615',
  twoFaAccessToken: null,
  authSecret: null,
  authEnabled: false,
  authType: null,
  allowedFeatures: null,
  isTestUser: false,
  createdAt: '2021-03-03T08:46:01.673Z',
  updatedAt: '2021-03-10T13:01:18.293Z',
  createdBy: 1,
  updatedBy: 421,
};
